export const menuDetailFeatureTranslationJP = {
  menuDetailFeature: {
    Component: {
      csv_output: 'csv output',
      delete: 'delete',
      close: '閉じる',
      setting: 'setting',
      search: 'search',
      reload: 'reload',
      detail: 'detail',
      save_btn: '保存',
      change_btn: '変更',
    },
    Text: {
      menu_detail_normal: 'メニュー詳細',
      menu_detail_sub: 'メニュー詳細',
      all: '全て',
      japanese: '日本語',
      english: '英語',
      simplified_chinese: '中国語(簡体字)',
      traditional_chinese: '中国語(繫体字)',
      korean: '韓国語',
      vietnamese: 'ベトナム語',
      display_name: '表示名',
      remarks: '備考',
      menu_settings: '〇メニュー設定',
      notice_text:
        '※モバイルオーダーの表示名、説明は、 <br />　日本語以外の言語を選択し、その言語が未設定の場合、 <br />　英語が表示されます。 <br />',
      register_information: '〇レジ情報',
      menu_name: 'メニュー名',
      menu_type: ' メニュー種別',
      display_timing: '表示条件',
      menu_property: 'プロパティ',
      menu_image: '画像',
      explanation: '説明',
      note1: '注釈１',
      note2: '注釈2',
      note3:
        '※制御条件が、表示制御グループのみ選択可能です<br />※表示制御グループは複数選択可能ですが、すべてのグループがオーダーされたときのみアクティブになります。',
      overlay_group: '任意オーバーレイ表示',
      default_overlay_group: '設定無し',
      order_limit_type: 'コース注文数制限',
      default_order_limit: '設定無し',
      note4:
        'こちらを設定した場合、コース詳細で注文数<br/>制限が有効になったコース対して、<br/>注文数の制限を行います。',
      control_condition: '制御条件',
      no_control: '制御なし',
      display_timing_group_radio: '表示タイミンググループ',
      display_control_group_radio: '表示制御グループ',
      display_timing_group_select: 'グループ選択：',
      display_timing_group_link: '表示タイミング設定画面で管理 ►',
      group_not_selected: 'グループ未選択',
      no_timing_group_available: '表示タイミンググループが未作成です。設定画面で作成してください。',
      conditions_not_set: '条件未設定',
      conditions_title: 'の適用条件',
      conditions_weekday: '曜日',
      conditions_schedule: '日程',
      conditions_schedule_none: '指定なし',
      conditions_time: '時間帯',
      conditions_time_none: '指定なし',
      conditions_grace: '猶予',
      conditions_grace_min: '分',
      conditions_note:
        '※ 曜日・日程・時間帯は表示タイミング設定画面で定義され、変更すると所属メニュー全件に反映されます（参照型）。',
      overlay_option_label: '非表示オプション',
      overlay_option_subtitle: '条件外の挙動・メニュー個別に設定',
      overlay_show: '表示する',
      overlay_show_desc: '条件外もオーバーレイで表示し、注文不可を案内する',
      overlay_uncheck_note: '※ チェックしない場合は「非表示」（条件外はメニュー自体を表示しない）',
      overlay_comment_label: '表示コメント',
      overlay_comment_subtitle: '「表示する」選択時のみ',
      overlay_default_message: 'この時間帯は注文できません',
      overlay_default_note: '※ 未入力時のデフォルト：「この時間帯は注文できません」',
      display_control_group: '表示制御　<br/>グループ：',
      sub_menu_settings: '〇サブメニュー設定',
      sub_menu_property: 'サブメニュー属性',
      provide_content: '提供内容：',
      limit_and_option: '制限・オプション：',
      limit_and_option_enabled: '提供タイミング： 有効（レジデータ取込から取得）',
      limit_and_option_disabled: '提供タイミング： 無効（レジデータ取込から取得）',
      wizard_title: 'ウィザード : ',
      invalid: '無効',
      promotional_image: 'プロモーション<br/>画像',
      hide_option: '非表示',
    },
    Table: {
      date_of_expired: '有効期限',
      start: '開始',
      end: '終了',
      pos_cd: 'POSコード',
      pos_name: 'POS名',
      amount_of_money_excluding_tax: '金額<br/>(税抜き)',
      amount_of_money_including_tax: '金額<br />（税込み） <br />※レジデータ取 <br />込から取得',
      normal: '通常',
      sub: 'サブ',
      normal_price_including_tax: '通常金額<br/>(税込み)',
      sub_price_including_tax: 'サブ金額<br/>(税込み)',
    },
    Form: {
      title_success: '成功',
      save_success: '保存しました',
      required: '必須フィールド',
    },
  },
};
